import React from 'react';
import Head from 'next/head';

import { makeScript, preConnect } from '../script';

export interface RedditPixelScriptProps {
  pixelID?: string;
}

/**
 * Script function.
 *
 * @param ctx
 */
function rdt(ctx: RedditPixelScriptProps) {
  /*eslint-disable */
  // prettier-ignore
  if (ctx.pixelID) {
    // @ts-ignore
    !function(w,d){
      // @ts-ignore
      if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}
    }(window,document);

    window.redditPixelID = ctx.pixelID;

    if (window.rdt) {
      window.rdt('init', window.redditPixelID);
    }
  }
}

export const RedditPixelScript = (props: RedditPixelScriptProps): JSX.Element => {
  const pixelID = props.pixelID || process.env.NEXT_PUBLIC_REDDIT_PIXEL_ID;
  return (
    <Head>
      {pixelID && preConnect('https://www.redditstatic.com')}
      {pixelID && makeScript(rdt, { pixelID })}
    </Head>
  );
};

export default RedditPixelScript;
